import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

export const AdminLogin = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    // FastAPI richiede un formato x-www-form-urlencoded per OAuth2
    const formData = new URLSearchParams();
    formData.append("username", "admin"); // Lo username è richiesto dal backend ma non lo validiamo
    formData.append("password", password);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/login`,
        formData,
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      const token = response.data.access_token;
      
      // Salva nel localStorage per mantenere la sessione al refresh
      localStorage.setItem("adminToken", token);
      
      toast.success("Accesso autorizzato", {
        description: "Identità confermata. Benvenuto, Comandante.",
      });
      
      onLoginSuccess(token);
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Accesso negato", {
        description: "Password errata o server non raggiungibile.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container" style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>AREA RISERVATA COMANDO</h2>
        <p style={styles.subtitle}>Inserire codice di accesso tattico</p>
        
        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="password"
            placeholder="Password di sistema"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? "VERIFICA IN CORSO..." : "AUTENTICAZIONE"}
          </button>
        </form>
        
        <button 
          onClick={() => window.location.hash = ""} 
          style={styles.backButton}
        >
          Torna al sito pubblico
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#09090B",
  },
  card: {
    background: "#0F0F11",
    padding: "40px",
    borderRadius: "8px",
    border: "1px solid #27272A",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
  },
  title: {
    color: "#EDEDED",
    fontSize: "1.5rem",
    letterSpacing: "2px",
    marginBottom: "10px",
  },
  subtitle: {
    color: "#A1A1AA",
    fontSize: "0.9rem",
    marginBottom: "30px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  input: {
    padding: "12px",
    background: "#18181B",
    border: "1px solid #27272A",
    borderRadius: "4px",
    color: "white",
    fontSize: "1rem",
    outline: "none",
  },
  button: {
    padding: "12px",
    background: "#EDEDED",
    color: "#09090B",
    border: "none",
    borderRadius: "4px",
    fontWeight: "800",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  backButton: {
    marginTop: "20px",
    background: "none",
    border: "none",
    color: "#71717A",
    cursor: "pointer",
    fontSize: "0.8rem",
    textDecoration: "underline",
  }
};